import { Children, cloneElement, ReactElement } from 'react';
import styles from '../styles.module.scss';
import { isReactElementWithProps } from 'components/types';

interface LeftGroupProps {
  children: ReactElement | (ReactElement | boolean)[] | boolean;
}

const LeftGroup = ({ children }: LeftGroupProps) => (
  <div className={styles.leftGroup}>
    {Children.map(children, (child) => {
      if (isReactElementWithProps(child)) {
        return cloneElement(child, {
          ...child.props,
          className: `${child.props.className} ${styles.button}`,
        });
      }
    })}
  </div>
);

LeftGroup.displayName = 'LeftGroup';

export default LeftGroup;
